import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgStars = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.1442 5.35799L14.0834 6.16657L14.8922 8.10575C14.9137 8.14912 14.9469 8.18562 14.9881 8.21113C15.0292 8.23665 15.0767 8.25016 15.1251 8.25016C15.1735 8.25016 15.221 8.23665 15.2621 8.21113C15.3033 8.18562 15.3365 8.14912 15.358 8.10575L16.1667 6.16657L18.106 5.35799C18.1492 5.33637 18.1856 5.30313 18.211 5.26199C18.2365 5.22085 18.2499 5.17344 18.2499 5.12508C18.2499 5.07672 18.2365 5.02931 18.211 4.98817C18.1856 4.94704 18.1492 4.91379 18.106 4.89217L16.1667 4.08351L15.358 2.14441C15.3365 2.10104 15.3033 2.06455 15.2621 2.03903C15.221 2.01352 15.1735 2 15.1251 2C15.0767 2 15.0292 2.01352 14.9881 2.03903C14.9469 2.06455 14.9137 2.10104 14.8922 2.14441L14.0834 4.08351L12.1442 4.89217C12.1009 4.91379 12.0645 4.94704 12.0391 4.98817C12.0137 5.02931 12.0002 5.07672 12.0002 5.12508C12.0002 5.17344 12.0137 5.22085 12.0391 5.26199C12.0645 5.30313 12.1009 5.33637 12.1442 5.35799ZM16.2302 12.4411L12.1365 11.8437L10.3042 8.12505C9.97645 7.46104 9.02734 7.4531 8.6953 8.12505L6.86299 11.8437L2.76928 12.4411C2.03501 12.5467 1.73777 13.453 2.27306 13.9724L5.2382 16.8628L4.53506 20.9482C4.40994 21.6867 5.18693 22.2415 5.83575 21.8936L9.49976 19.9644L13.1638 21.8936C13.3119 21.9714 13.4788 22.0062 13.6456 21.9941C13.8124 21.982 13.9726 21.9235 14.1079 21.8251C14.2432 21.7268 14.3483 21.5925 14.4113 21.4376C14.4743 21.2826 14.4927 21.1131 14.4645 20.9482L13.7656 16.8628L16.7301 13.9724C17.2617 13.453 16.9645 12.5467 16.2302 12.4411ZM21.8849 10.5636L20.3336 9.91684L19.6867 8.36566C19.6695 8.33097 19.6429 8.30178 19.61 8.28138C19.5771 8.26097 19.5391 8.25016 19.5004 8.25016C19.4616 8.25016 19.4237 8.26097 19.3907 8.28138C19.3578 8.30178 19.3313 8.33097 19.314 8.36566L18.6671 9.91684L17.1159 10.5636C17.0813 10.5809 17.0522 10.6075 17.0318 10.6404C17.0115 10.6733 17.0007 10.7113 17.0007 10.7499C17.0007 10.7886 17.0115 10.8266 17.0318 10.8595C17.0522 10.8924 17.0813 10.919 17.1159 10.9363L18.6671 11.5831L19.314 13.1342C19.3312 13.1689 19.3578 13.1981 19.3907 13.2186C19.4237 13.239 19.4616 13.2498 19.5004 13.2498C19.5391 13.2498 19.5771 13.239 19.61 13.2186C19.6429 13.1981 19.6695 13.1689 19.6867 13.1342L20.3336 11.5831L21.8849 10.9363C21.9195 10.919 21.9486 10.8924 21.9689 10.8595C21.9892 10.8266 22 10.7886 22 10.7499C22 10.7113 21.9892 10.6733 21.9689 10.6404C21.9486 10.6075 21.9195 10.5809 21.8849 10.5636Z", fill: props.fill }));
});
export default SvgStars;
